module.exports = {"id":"dp5_1l1q3","text":"Operating systems and software","instructions":"Which option best describes an operating system?","multiselect":false,"category":"5.1","questionType":"PickOne","random":true,"options":[{"id":"dp5_1l1q3-a1","text":"Software managing device resources","score":1.8},{"id":"dp5_1l1q3-a2","text":"Program for writing documents","score":0},{"id":"dp5_1l1q3-a3","text":"Tool for browsing websites","score":0}],"groupTitle":"Digital Profiler Knowledge Matrix"}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat5.1/l1q3.json
// module id = 1283
// module chunks = 41